/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * Artionet Web Agency
 * (c) copyright 2018 Artionet Web Agency
 *
 * Material Blue Palette
 */
export default {
    accentColor : "#42A5F5", //400
    darkPrimaryColor : "#0D47A1", //900
    dividerColor : "#BBDEFB", //100
    error: "#ef5350",
    lightPrimaryColor : "#90CAF9", //200
    primaryColor : "#1976D2", //700
    primaryText : "#212121",
    secondaryText : "#9B9B9B",
    success: "#2FCF70",
    text : "#FFFFFF",
    whiteTransparency90: "rgba(255, 255, 255, 0.9"
};



// WEBPACK FOOTER //
// ./src/app/managers/ColorManager.ts